<template>
  <div>
    <b-form-row class="mt-3 mb-2">
      <b-col cols="12">
        <b-button
          class="mb-2 mb-sm-0 mr-sm-2 btn-responsive"
          size="sm"
          variant="primary"
          :disabled="!isChosenVisible"
          @click="toggleSelectAll"
        >
          {{ selectAll ? 'Unselect all rows' : 'Select all rows' }}
        </b-button>

        <b-button
          class="mb-2 mb-sm-0 btn-responsive"
          size="sm"
          variant="danger"
          :disabled="!hasValda"
          @click="excludeSelectedRows"
        >
          Exclude selected rows
        </b-button>
        <label class="campaignRowsStyle"> {{ getRowCount }} </label>
        <label class="excludedRowsStyle"> {{ numberOfExcludedRowsText }} </label>
      </b-col>
    </b-form-row>
    <b-table
      id="table-rows"
      class="mb-2 mt-2"
      :busy="isBusy"
      :bordered="true"
      :striped="true"
      :head-variant="'dark'"
      hover
      sort-icon-left
      :items="items"
      :fields="fields"
      :small="true"
      :responsive="true"
      primary-key="rowNum"
      sort-compare-locale="sv"
      :sort-desc.sync="sortDesc"
      :sort-by.sync="sortBy"
      no-sort-reset
      sort-direction="desc"
      :per-page="perPage"
      :current-page="currentPage"
      :no-local-sorting="true"
      @row-clicked="rowClicked"
      @sort-changed="onSort"
    >
      <template
        v-if="sumVisible"
        v-slot:top-row
      >
        <td :colspan="sumArrayColspan">
          <div class="sumrowtop">
            <div
              v-for="(sum, iSum) in summaryArray"
              :key="iSum"
              class="sumrowdiv"
            >
              <span>{{ sum.name }}:</span>
            </div>
          </div>
        </td>
        <td
          v-for="(measure, iMeasure) in measuresInTable"
          :key="iMeasure"
          class="text-right"
          colspan="1"
        >
          <div
            v-for="(sum, iSum) in summaryArray"
            :key="iSum"
            class="sumrowdiv"
          >
          {{ sum.measures[measure.key] }}
          </div>
        </td>
      </template>
      <template v-slot:cell(valda)="row">
        <template v-if="row.value">
          <b-checkbox
            v-model="row.value"
            class="avoid-clicks"
            aria-hidden="true"
          />
          <span class="sr-only">Selected</span>
        </template>
        <template v-else>
          <b-checkbox
            v-model="row.value"
            class="avoid-clicks"
            aria-hidden="true"
          />
          <span class="sr-only">Not selected</span>
        </template>
      </template>
      <template v-slot:cell(filmcode)="data">
        <div class="textSelect">
          {{ data.value }}
        </div>
      </template>
    </b-table>
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      :per-page="perPage"
    />
  </div>
</template>

<script>
import { addDays, daysBetween } from '../../../assets/js/utils.js';
import { bus } from '../../../main';

export default {
  name: 'CampaignResultTable',
  data() {
    return {
      selectAll: false,
      latestRowClicked: null,
      shiftKey: false,
      isBusy: false,
      currentPage: 1,
      perPage: 50
    };
  },
  computed: {
    sumVisible() {
      return this.$store.getters[`campaignResults/getSumVisible`];
    },
    sortBy: {
      get() {
        return this.$store.state.campaignApiBody.payload.sort_by;
      },
      set(value) {
        return value;
      },
    },
    sortDesc: {
      get() {
        return this.$store.state.campaignApiBody.payload.sort_direction == 'DESC';
      },
      set(value) {
        return value;
      },
    },
    items() {
      let items = this.$store.state.campaignResults.results;
      return items;
    },
    fields() {
      /*
      let fields = this.$store.state.campaignResults.resultFields;
       if(this.config_ShowFilmType == false)
      {
         fields = fields.filter(field => field.key !== 'type');
      }
         */
      return   this.$store.state.campaignResults.resultFields.filter(z => z.visible == true);
      
    },
    rows() {
      return this.$store.state.campaignResults.results.length;
    },
    measuresInTable() {
      return this.$store.getters[`campaignResults/getMeasuresInTable`];
    },
    summaryArray() {
      return this.$store.state.campaignResults.summaryArray;
    },
    selectedRows() {
      return this.$store.state.campaignResults.results.filter(item => item.valda).length;
    },
    hasSelection() {
      return this.$store.state.campaignReachApiBody.payload.queryKeys.length > 0;
    },
    hasValda() {
      return this.$store.state.campaignResults.results.some(item => item.valda === true);
    },
    getRowCount() {
      let previousRowsAndCurrentRows = this.perPage * this.currentPage
      if (previousRowsAndCurrentRows > this.rows) {
        return `${this.rows}/${this.rows}`
      }
      return `${previousRowsAndCurrentRows}/${this.rows}`
    },
    isChosenVisible() {
      let isChosenVisible = true;
      let chosenFields = this.fields.filter(item => item.key === 'valda');
      if (chosenFields.length == 0) isChosenVisible = false;
      return isChosenVisible;
    },
    numberOfExcludedRowsText() {
      let excludedRowsText = "";
      let numberOfExcludedRows = this.$store.state.campaignResults.totalRowCount - this.rows
      if(numberOfExcludedRows > 0)
        excludedRowsText = `(${numberOfExcludedRows} excluded)`
      return excludedRowsText;
    },
    sumArrayColspan() {
      return this.fields.filter(f => f.tdClass !== "d-none" && !f.isMeasure).length
    }
  },
  mounted() {
    document.addEventListener('keydown', e => {
      if (e.key === 'Shift') {
        this.shiftKey = true;
      }
    });

    document.addEventListener('keyup', e => {
      if (e.key === 'Shift') {
        this.shiftKey = false;
      }
    });

    bus.$on('searching', () => {
      this.selectAll = false;
    });
  },
  methods: {
    rowClicked(item) {
      if (!this.fields.some(f => f.key === 'valda')) return;
      
      const currentIndex = this.$store.state.campaignResults.results.findIndex(
        element => element.rowNum === item.rowNum
      );
      const rowSelected = this.$store.state.campaignResults.results[currentIndex]?.valda;

      if (this.shiftKey && this.latestRowClicked !== null) {
        const lastClickedIndex = this.$store.state.campaignResults.results.findIndex(
          element => element.rowNum === this.latestRowClicked
        );

        const minIndex = Math.min(currentIndex, lastClickedIndex);
        const maxIndex = Math.max(currentIndex, lastClickedIndex);
        
        // Check if we're selecting or deselecting based on the clicked row's state
        const targetState = !rowSelected;

        // Apply the same state to all rows in the range
        for (let i = minIndex; i <= maxIndex; i++) {
          const rowNum = this.$store.state.campaignResults.results[i].rowNum;
          if (targetState) {
            this.$store.commit('campaignResults/select', rowNum);
          } else {
            this.$store.commit('campaignResults/deselect', rowNum);
          }
        }
      } else {
        // Single row toggle
        if (rowSelected) {
          this.$store.commit('campaignResults/deselect', item.rowNum);
        } else {
          this.$store.commit('campaignResults/select', item.rowNum);
        }
        
        this.latestRowClicked = item.rowNum;
      }

      this.updateReachApiBodyCampaign();
    },
    async onSort(item) {
      this.isBusy = true;
      this.latestRowClicked = null;

      await Promise.all([
        this.$store.commit('campaignApiBody/updateSortBy', item.sortBy),
        this.$store.commit('campaignApiBody/updateSortDirection', item.sortDesc ? 'DESC' : 'ASC')
      ]);
      
      this.$emit('sort-changed', item);
      this.isBusy = false;
    },
    async excludeSelectedRows() {   
      this.isBusy = true;
      
      // Get selected rows before excluding them
      const selectedRows = this.$store.state.campaignResults.results
        .filter(item => item.valda)
        .map(item => item.rowNum);
      
      this.$store.commit('campaignApiBody/updateExcludedRows', selectedRows);
      this.$store.commit('campaignReachApiBody/emptyQueryKeys');
      
      // Emit event for parent to handle
      this.$emit('exclude-rows');
      
      this.selectAll = false;
      this.isBusy = false;      
    },
    toggleSelectAll() {  
      this.latestRowClicked = null;
      if (!this.selectAll) {
        this.selectAll = true;
        this.$store.commit('campaignResults/selectAll');
        this.updateReachApiBodyCampaign();
      } else {
        this.$store.commit('campaignResults/unselectAll');
        this.selectAll = false;
      }
      this.updateReachApiBodyCampaign();
    },
    updateReachApiBodyCampaign() {
      let queryKeys = [];

      let minDate = '';
      let maxDate = '';

      this.items.forEach(element => {
        if (element.valda === true) {
          let date = new Date(element.consumed_at);

          if (minDate) {
            let minDateCompare = new Date(minDate);

            if (date < minDateCompare) {
              minDate = element.consumed_at;
            }
          } else {
            minDate = element.consumed_at;
          }

          if (maxDate) {
            let maxDateCompare = new Date(maxDate);

            if (date > maxDateCompare) {
              maxDate = element.consumed_at;
            }
          } else {
            maxDate = element.consumed_at;
          }
        }
      });

      let days = daysBetween(minDate, maxDate);
      //Max days to transfere to reach is 28
      if (days < this.config_MaxReachDays) {
        this.$store.commit('campaignReachApiBody/updateAutoChangeEndDate', false);
        this.items.forEach(element => {
          if (element.valda === true) {
            let queryKey = [element.spot_key, element.consumed_at, element.site_id].join(';');
            queryKeys.push(queryKey);
          }
        });
      } else {
        //adjust the result to match 28 days
        maxDate = addDays(minDate, this.config_MaxReachDays - 1);
        this.$store.commit('campaignReachApiBody/updateAutoChangeEndDate', true);
        //Change date for queryKey
        this.items.forEach(element => {
          if (element.valda === true) {
            let queryKey = '';
            if (element.consumed_at <= maxDate) {
              queryKey = [element.spot_key, element.consumed_at, element.site_id].join(';');
            } else {
              queryKey = [element.spot_key, maxDate, element.site_id].join(';');
            }
            queryKeys.push(queryKey);
          }
        });
      }

      this.$store.commit('campaignReachApiBody/updateQueryKeys', queryKeys);
      this.$store.commit('campaignReachApiBody/updateStartDate', minDate);
      this.$store.commit('campaignReachApiBody/updateEndDate', maxDate);
    },
  },
};
</script>
<style scoped>
.campaignRowsStyle {
  margin-left: 10px;
  margin-top: 8px;
}
.pagination {
  justify-content: center;
}
</style>
